<template>
  <div>
    <b-card-text>
      <small>
        {{ cart.qty }} x ${{ cart.Product.price }} : {{ cart.Product.name }}
      </small>
    </b-card-text>
  </div>
</template>

<script>
export default {
  name: 'SummaryList',
  props: ['cart'],
  methods: {
    checkValue () {
      if (this.cart.qty > this.cart.Product.stock) {
        this.cart.qty = this.cart.Product.stock
      }
    }
  },
  created () {
    this.checkValue()
  }
}
</script>

<style>

</style>
